import Vue from 'vue'
import Router from 'vue-router'
import SafeMap from '../components/achievement/SafeMap'
import SafeResult from '../components/achievement/SafeResult'
import CoreRisk from '../components/achievement/CoreRisk'
import KpiMonitoring from "../components/achievement/KpiMonitoring";
import Layout from "../components/achievement/Layout";
import JumpToSmsReport from '../components/system/JumpToSmsReport'
import LocalLogin from "../components/system/LocalLogin";
import NotFound from "../components/system/NotFound";
import Setting from "../components/admin/Setting"
import KeyProcess from "../components/achievement/KeyProcess";
import SafeMapCaac from "../components/achievement/SafeMapCaac";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/safetyperformance",
      component: Layout,
      children: [
        {
          name: "safeMap",
          path: "map",
          component: SafeMapCaac
        },
        {
          name: "safeMapHu",
          path: "map-hu",
          component: SafeMap
        },
        {
          name: "safeResult",
          path: "result",
          component: SafeResult
        },
        {
          name: "coreRisk",
          path: "risk",
          component: CoreRisk
        },
        {
          name: "keyProcess",
          path: "process",
          component: KeyProcess
        },
        {
          name: "kpiMonitoring",
          path: "kpi/monitoring",
          component: KpiMonitoring
        },
        {
          name: "operationOverview",
          path: "operation/overview",
          component: () => import("../components/achievement/OperationOverview")
        },
        {
          name: "safeExamine",
          path: "safe/examine",
          component: () => import("../components/achievement/safeExamine")
        },
        {
          path: "",
          redirect: "map"
        },
      ]
    },
    {
      path: "/admin",
      component: Layout,
      children: [
        {
          path: "setting",
          component: Setting
        }
      ]
    },
    {
      name: "localLogin",
      path: "/login",
      component: LocalLogin,
      props: true,
    },
    {
      path: "/welcome",
      component: JumpToSmsReport
    },
    {
      path: "/sso",
      component: Layout,
      children: [
        {
          path: "sms-repo-auth",
          component: () => import("../components/system/sso/SmsRepoAuth")
        },
        {
          path: "sms-auth",
          component: () => import("../components/system/sso/SmsAuth")
        }
      ]
    },
    {
      path: "/",
      redirect: "/safetyperformance"
    },
    {
      path: '*',
      component: NotFound
    }
  ],
  base: process.env.contextBase,
  mode: process.env.routerMode
})



// WEBPACK FOOTER //
// ./src/router/index.js